<template>
    <header-layout :user="user">
        <template #left_section>
            <li class="nav-item d-none d-md-block">
                <router-link
                    :to="{ name: 'company'}"
                    class="nav-link d-flex align-items-center px-2 text-primary" target="_self"
                >
                    <vue-feather class="mr-50" type="home" size="15"></vue-feather>
                    <span>{{ localizationStore.translate('Dashboard') }}</span>
                </router-link>
            </li>
            <li class="nav-item d-none d-md-block">
                <router-link
                    :to="{ name: 'team-index'}"
                    class="nav-link d-flex align-items-center px-2 text-primary" target="_self"
                >
                    <vue-feather class="mr-50" type="users" size="15"></vue-feather>
                    <span>{{ localizationStore.translate('Teams') }}</span>
                </router-link>
            </li>
            <li class="nav-item d-none d-md-block">
                <router-link
                    :to="{ name: 'opportunities.pipeline'}"
                    class="nav-link d-flex align-items-center px-2" target="_self"
                >
                    <vue-feather class="mr-50" type="target" size="15"></vue-feather>
                    <span>{{ localizationStore.translate('opportunities.pipeline') }}</span>
                </router-link>
            </li>
            <li class="nav-item">
                <router-link
                    :to="{ name: 'referrals'}"
                    aria-current="page"  class="d-flex align-items-center" target="_self"
                >
                    <vue-feather type="dollar-sign" class="mr-50" size="15"></vue-feather>
                    <span class="menu-title">{{ localizationStore.translate('Affliates') }}</span>
                </router-link>
            </li>
            <li class="nav-item d-none d-md-block">
                <router-link
                    :to="{ name: 'knowledge-base-index'}"
                    class="nav-link d-flex align-items-center px-2 text-primary" target="_self"
                >
                    <vue-feather class="mr-50" type="book-open" size="15"></vue-feather>
                    <span> {{ localizationStore.translate('Knowledge Base') }} </span>
                </router-link>
            </li>
            <li class="nav-item d-none d-md-block">
                <router-link
                    :to="{ name: 'products'}"
                    class="nav-link d-flex align-items-center px-2" target="_self"
                >
                    <vue-feather class="mr-50" type="book" size="15"></vue-feather>
                    <span>{{ localizationStore.translate('ebook') }}</span>
                </router-link>
            </li>
            <li class="nav-item d-none d-md-block">
                <router-link
                    :to="{ name: 'chat-index'}"
                    class="nav-link d-flex align-items-center px-2 text-primary"
                    target="_self"
                >
                    <vue-feather class="mr-20" type="message-square" size="15"></vue-feather>
                    <span>{{ localizationStore.translate('chat.navbar.title') }}</span>
                </router-link>
            </li>
            <li class="nav-item d-none d-md-block">
                <router-link
                    :to="{ name: 'messages'}"
                    aria-current="page" class="nav-link d-flex align-items-center text-primary" target="_self"
                    style="position: relative;"
                >
                    <div class="new-message" v-if="messageStore.newMessages" style="left: 12px !important;"></div>
                    <vue-feather class="mr-50" type="message-circle" size="15"></vue-feather>
                    <span>{{ localizationStore.translate('messages') }}</span>
                </router-link>
            </li>
            <li class="nav-item d-none d-md-block">
                <a @click="logout" href="#" class="nav-link d-flex align-items-center px-2 text-primary" target="_self">
                <vue-feather class="mr-50" type="log-out"></vue-feather>
                <span>{{ localizationStore.translate('UserLogout') }}</span></a>
            </li>

        </template>
    </header-layout>
    <nav-bar-layout :user="user">
        <template #right_slot>
            <li class="nav-item active">
                <router-link
                    :to="{ name: 'company'}"
                    target="_self" class="d-flex align-items-center"
                >
                    <vue-feather class="mr-50" type="home"></vue-feather>
                    <span>{{ localizationStore.translate('Dashboard') }}</span>
                </router-link>
            </li>
            <li class="nav-item active">
                <router-link
                    :to="{ name: 'chat-index'}"
                    class="d-flex align-items-center"
                    target="_self"
                >
                    <vue-feather class="mr-20" type="message-square" size="15"></vue-feather>
                    <span>{{ localizationStore.translate('chat.navbar.title') }}</span>
                </router-link>
            </li>
            <li class="nav-item">
                <router-link
                    :to="{ name: 'products'}"
                    class="d-flex align-items-center" target="_self"
                >
                    <vue-feather class="mr-50" type="book" size="15"></vue-feather>
                    <span>{{ localizationStore.translate('ebook') }}</span>
                </router-link>
            </li>
            <li class="nav-item">
                <router-link
                    :to="{ name: 'knowledge-base-index'}"
                    target="_self" class="d-flex align-items-center"
                >
                    <vue-feather type="book-open"></vue-feather>
                    <span class="menu-title text-truncate">{{ localizationStore.translate('Knowledge Base') }}</span>
                </router-link>
            </li>
            <li class="navigation-header  text-truncate">
                <span>{{ localizationStore.translate('Refer Friends & Family') }}</span>
                <vue-feather type="more-horizontal"></vue-feather>
            </li>
            <li class="nav-item">
                <router-link
                    :to="{ name: 'referrals'}"
                    target="_self" class="d-flex align-items-center"
                >
                    <vue-feather data-feather="dollar-sign"></vue-feather>
                    <span class="menu-title text-truncate">{{ localizationStore.translate('Affliates') }}</span>
                </router-link>
            </li>
            <li class="navigation-header text-truncate">
                <span>{{ localizationStore.translate('Creditfixrr Blog') }}</span>
                <vue-feather data-feather="more-horizontal"></vue-feather>
            </li>
            <li class="nav-item">
                <router-link
                    :to="{ name: 'blogs'}"
                    target="_self" class="d-flex align-items-center"
                >
                    <vue-feather type="book-open"></vue-feather>
                    <span class="menu-title text-truncate">{{ localizationStore.translate('Blog') }}</span>
                </router-link>
            </li>

            <li class="navigation-header  text-truncate">
                <span>{{ localizationStore.translate('User Settings') }}</span>
                <vue-feather type="more-horizontal"></vue-feather>
            </li>
            <li class="nav-item">
                <a  href="https://creditfixrr.crunch.help/en" class="d-flex align-items-center" >
                    <i data-feather="help-circle"></i>
                    <span class="menu-title text-truncate">{{ localizationStore.translate('faq') }}</span>
                </a>
            </li>
            <li class="nav-item">
                <a @click="logout" href="#" class="d-flex align-items-center">
                    <vue-feather type="log-out" />
                    <span class="menu-title text-truncate">{{ localizationStore.translate('UserLogout') }}</span>
                </a>
            </li>
        </template>
    </nav-bar-layout>
</template>
<script>
import { ref } from 'vue'
import { useLocalizationStore } from '../../../stores/LocalizationStore.js'
import { useSettingStore } from '../../../stores/SettingStore.js'
import HeaderLayout from './layouts/HeaderLayout'
import NavBarLayout from './layouts/NavBarLayout'
import { useUserStore } from '../../../stores/UserStore'
import { useMessageStore} from '../../../stores/MessageStore'
export default {
    components:{
        HeaderLayout,NavBarLayout
    },
    props:{
        user:{
            type:[Array,Object]
        },
    },
    setup(props){
        const localizationStore = useLocalizationStore();
        const settingStore = useSettingStore();
        const siteUrl = ref(null);
        const userInfo = props.user
        return{
            localizationStore,settingStore,siteUrl,userInfo,
            userStore:useUserStore(),
            messageStore:useMessageStore()
        }
    },
    created(){
        this.siteUrl = baseUrl;
    },
    watch: {
        'userStore.user'(value) {
            if (value != null) {
                let ownerId;
                this.userInfo = value;
                if(this.userInfo.isClient){
                    ownerId = this.userInfo.owner.id
                }else{
                    ownerId = this.userInfo.teams[0].admin.id
                }
                Echo.channel('RoomMesssage.' + ownerId)
                .listen('.new-message', (e) => {
                    if(e.response){
                        if(_.includes(['client-messages','messages'], this.$route.name)){
                            this.messageStore.newMessages = false;
                        }else{
                            this.messageStore.newMessages = true
                        }

                    }else{
                        this.messageStore.newMessages = false
                    }

                });
            }
        },


    },
    mounted(){
        if(_.includes(['client-messages','messages'], this.$route.name)){
            this.messageStore.newMessages = false;
        }else{
            this.messageStore.checkNewMessage();
        }

    },
    methods:{
        logout() {
            const route = this.$router.resolve({ name: 'logout-link'}).href;
            axios.get(route)
            .then(function (response) {
                localStorage.clear();
                location.reload();
            });
        }
    }
}
</script>
